import React from 'react';

const AddressDisplay = ({ address }) => {
    // Handle null/undefined
    if (!address) return <span className="text-gray-400 text-xs">No address</span>;

    // Parse if string
    let addr;
    try {
        addr = typeof address === 'string'
            ? JSON.parse(address)
            : address;
    } catch (e) {
        return <span className="text-red-400 text-xs">Invalid address</span>;
    }

    return (
        <div className="text-xs text-gray-700 max-w-xs">
            {addr.tag && <div className="font-semibold text-gray-800">{addr.tag}</div>}
            {addr.line1 && addr.line1 !== ',' && <div>{addr.line1}</div>}
            {addr.line2 && <div>{addr.line2}</div>}
            {addr.landmark && <div className="text-gray-500">Near: {addr.landmark}</div>}
            {addr.pincode && <div className="text-gray-600">PIN: {addr.pincode}</div>}
        </div>
    );
};

export default AddressDisplay;
